import type { ReactNode } from 'react';
import { PortalProps,Tooltip as MantineTooltip } from '@mantine/core';
import { type FloatingPosition } from '@mantine/core';
import clsx from 'clsx';

import styles from './tooltip.module.scss';

export type TooltipProps = {
  /** Tooltip target element */
  children: ReactNode;
  /** Determines whether tooltip should be rendered within Portal */
  disabled?: boolean;
  /** Tooltip label */
  label: ReactNode;
  /** Tooltip position relative to target element */
  position?: FloatingPosition;
  /** Props to pass down to the portal when withinPortal is true */
  portalProps?: Omit<PortalProps, 'children'>;
  /** Determines whether tooltip should be rendered within Portal */
  usePortal?: boolean;
  /** fixed tooltip width specified as css value, e.g. '160px', '5rem' or 'auto' */
  width?: string;
};

/**
 * Standard themed Tooltip component
 */
export const Tooltip = ({
  children,
  disabled,
  label,
  position = 'top',
  portalProps,
  usePortal = true,
  width = 'auto',
}: TooltipProps) => {
  return (
    <MantineTooltip
      arrowSize={12}
      classNames={{
        tooltip: clsx(styles['root']),
        arrow: clsx(styles['arrow']),
      }}
      disabled={disabled}
      style={{ width }}
      label={label}
      multiline
      portalProps={{ ...portalProps }}
      position={position}
      withArrow
      withinPortal={usePortal}
    >
      {children}
    </MantineTooltip>
  );
};
